import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/returns/$returnId/review')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/returns/$returnId',
      params: { returnId: params.returnId },
      hash: 'section-review',
    });
  },
});
